module.exports = __webpack_public_path__ + "static/media/person-tomasz-pewinski.bb0ca850.png";